import { render, staticRenderFns } from "./ContactLeave.vue?vue&type=template&id=cc85323a&"
import script from "./ContactLeave.vue?vue&type=script&lang=js&"
export * from "./ContactLeave.vue?vue&type=script&lang=js&"
import style0 from "./ContactLeave.vue?vue&type=style&index=0&id=cc85323a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports